import { Logger } from '@sitecore-search/common';
import { WidgetDataType } from '@sitecore-search/models';
import BaseWidgetContextProvider from '../../providers/BaseWidgetContextProvider.js';
import WidgetContextProvider from '../../providers/WidgetContextProvider.js';
import { compose, createWidgetWrapperElement } from '../../providers/utils.js';
import ContentBlockComponent from '../../widgets/contentBlock/index.js';
import SEOComponent from '../../widgets/contentBlock/seo.js';
import { buildWidgetTypeComponent } from '../setup.js';
const createProviders = (props, config, WidgetComponent) => compose(BaseWidgetContextProvider, WidgetContextProvider)(createWidgetWrapperElement(WidgetComponent, props), config);
export const widget = (Component, type, entity) => {
    Logger.debug('widget', Component && Component.name, type);
    return buildWidgetTypeComponent(type, Component, entity, createProviders);
};
export const ContentBlock = ContentBlockComponent;
export const Banner = ContentBlockComponent;
export const HTMLBlock = ContentBlockComponent;
export const SEO = ContentBlockComponent;
export const BannerWidget = widget(ContentBlockComponent, WidgetDataType.BANNER, 'content');
export const HTMBlockWidget = widget(ContentBlockComponent, WidgetDataType.HTML_BLOCK, 'content');
export const SEOWidget = widget(SEOComponent, WidgetDataType.SEO, 'content');
